import * as React from "react";
import {deepPurple,} from "@mui/material/colors";
import {TextField, useRecordContext} from "react-admin";
import {Billing} from "../types";

const BillingStatusField = () => {
    const record = useRecordContext<Billing>();
    return (
        <TextField
            record={record}
            source="billingState"
            sx={{color: getStatusColor(record?.billingState)}}
        />
    );
};

BillingStatusField.defaultProps = {
    source: "billingState",
    label: "Billing State",
};

export function getStatusColor(state: string | undefined) {
    if (state) {
        return deepPurple["900"];
    }

    // fallback
    return "#000000";
}

export default BillingStatusField;
